import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: StrictMode intentionally disabled because react-leaflet@4 + Leaflet's
// imperative DOM init throws "Map container is already initialized" under
// React 18 StrictMode's double-mount cycle. App has been running without
// StrictMode in production builds anyway; this preserves dev/prod parity.
root.render(<App />);
